<script>
import Layout from "@/router/layouts/auth";
import { api } from "@/state/services";
import { mapState, mapActions } from "vuex";
import { required, email, minLength } from "vuelidate/lib/validators";
import {
  checkUsername,
  checkAge,
} from "@/state/validations/register";
import Password from "@/components/widgets/input-password";
import Languages from "@/components/widgets/languages";

export default {
  locales: {
    pt: {
      'Brazil': 'Brasil',
      'Paraguay': 'Paraguai',
      'Congratulations!': 'Parabéns!',
      'Your account was created successfully.': 'Sua conta foi criada com sucesso.',
      'Sponsor': 'Patrocinador',
      'Sponsor is required.': 'O patrocinador é obrigatório.',
      'Sponsor not found.': 'O patrocinador não foi encontrado.',
      'Person Type': 'Tipo de Pessoa',
      'Individual': 'Pessoa Física',
      'Company': 'Pessoa Jurídica',
      'Name is required.': 'O nome é obrigatório.',
      'Personal Information': 'Dados Pessoais',
      'Name': 'Nome',
      'Date of Birth': 'Data de Nascimento',
      'Date of birth is required.': 'A data de nascimento é obrigatória.',
      'You must be over 18 years old.': 'A idade deve ser maior que 18 anos.',
      'CPF': 'CPF',
      'CPF is required.': 'O CPF é obrigatório.',
      'The CPF entered is incorrect.': 'O CPF informado está incorreto.',
      'Cédula de Identidad': 'Cédula de Identidad',
      'RUC': 'RUC',
      'Company Information': 'Dados da Empresa',
      'Company Name': 'Razão Social',
      'Company name is required.': 'A razão social é obrigatória.',
      'CNPJ': 'CNPJ',
      'CNPJ is required.': 'O CNPJ é obrigatório.',
      'Incorporation Date': 'Data de Abertura',
      'Incorporation date is required.': 'A Data de Abertura é obrigatória.',
      'Contact Information': 'Contatos',
      'E-mail': 'E-mail',
      'E-mail is required.': 'O e-mail é obrigatório.',
      'The email you entered is incorrect.': 'O e-mail informado está incorreto.',
      'Mobile Phone': 'Celular',
      'Mobile phone is required.': 'O celular é obrigatório.',
      'Access Information': 'Dados de Acesso',
      'Username': 'Usuário',
      'Username is required.': 'O nome de usuário é obrigatório.',
      'The username entered is incorrect.': 'O nome de usuário informado está incorreto.',
      'Password': 'Senha',
      'Register': 'Cadastre-se',
      'Click here to sign in': 'Clique aqui para fazer o login',
      'Already have an account?': 'Já possui uma conta?',
      'Sign In here': 'Entrar',
      'REF.': 'REF.',
      'TECHNOLOGY BY': 'TECNOLOGIA POR',
      'You have successfully logged in.': 'Login realizado com sucesso.',
      'Your registration was successful.': 'Seu cadastro foi realizado com sucesso.',
      'Unable to register, please try again later.': 'Não foi possível realizar o cadastro, tente novamente mais tarde.',
      'The sponsor was not found or is still inactive.': 'O patrocinador não foi encontrado ou ainda está inativo.',
      'Enter your full name.': 'Informe o seu nome completo.',
      'Birthday is required.': 'A data de nascimento é obrigatória.',
      'The CPF entered is incorrect or already in use.': 'O CPF informado está incorreto ou já está sendo utilizado.',
      'Opening date is required.': 'A data de abertura é obrigatória.',
      'The CNPJ entered is incorrect or already in use.': 'O CNPJ informado está incorreto ou já está sendo utilizado.',
      'The mobile number entered is invalid.': 'O número de celular informado é inválido.',
      'The username cannot be only numbers.': 'O nome de usuário não pode ser apenas números.',
      'This username is already in use.': 'O nome de usuário já está em uso.',
      'Your username and password must be different.': 'Seu nome de usuário e sua senha devem ser diferentes.',
      'Fill in all required fields.': 'Preencha todos os campos obrigatórios.',
      'Change': 'Alterar',
      'Continue': 'Avançar',
      'Back': 'Voltar',
    },
    es: {
      'Brazil': 'Brasil',
      'Paraguay': 'Paraguay',
      'Congratulations!': '¡Felicidades!',
      'Your account was created successfully.': 'Tu cuenta fue creada exitosamente.',
      'Sponsor': 'Patrocinador',
      'Sponsor is required.': 'El patrocinador es obligatorio.',
      'Sponsor not found.': 'Patrocinador no encontrado.',
      'Person Type': 'Tipo de Persona',
      'Individual': 'Persona Física',
      'Company': 'Persona Jurídica',
      'Name is required.': 'El nombre es obligatorio.',
      'Personal Information': 'Datos Personales',
      'Name': 'Nombre',
      'Date of Birth': 'Fecha de Nacimiento',
      'Date of birth is required.': 'La fecha de nacimiento es obligatoria.',
      'You must be over 18 years old.': 'Debes ser mayor de 18 años.',
      'CPF': 'CPF',
      'CPF is required.': 'El CPF es obligatorio.',
      'The CPF entered is incorrect.': 'El CPF ingresado es incorrecto.',
      'Cédula de Identidad': 'Cédula de Identidad',
      'RUC': 'RUC',
      'Company Information': 'Datos de la Empresa',
      'Company Name': 'Razón Social',
      'Company name is required.': 'La razón social es obligatoria.',
      'CNPJ': 'CNPJ',
      'CNPJ is required.': 'El CNPJ es obligatorio.',
      'Incorporation Date': 'Fecha de Constitución',
      'Incorporation date is required.': 'La fecha de constitución es obligatoria.',
      'Contact Information': 'Contactos',
      'E-mail': 'Correo Electrónico',
      'E-mail is required.': 'El correo electrónico es obligatorio.',
      'The email you entered is incorrect.': 'El correo electrónico ingresado es incorrecto.',
      'Mobile Phone': 'Celular',
      'Mobile phone is required.': 'El teléfono móvil es obligatorio.',
      'Access Information': 'Datos de Acceso',
      'Username': 'Nombre de Usuario',
      'Username is required.': 'El nombre de usuario es obligatorio.',
      'The username entered is incorrect.': 'El nombre de usuario ingresado es incorrecto.',
      'Password': 'Contraseña',
      'Register': 'Registrarse',
      'Click here to sign in': 'Haz clic aquí para iniciar sesión',
      'Already have an account?': '¿Ya tienes una cuenta?',
      'Sign In here': 'Iniciar sesión',
      'REF.': 'REF.',
      'TECHNOLOGY BY': 'TECNOLOGÍA POR',
      'You have successfully logged in.': 'Has iniciado sesión con éxito.',
      'Your registration was successful.': 'Tu registro se realizó con éxito.',
      'Unable to register, please try again later.': 'No fue posible completar el registro, inténtalo de nuevo más tarde.',
      'The sponsor was not found or is still inactive.': 'El patrocinador no fue encontrado o aún está inactivo.',
      'Enter your full name.': 'Ingresa tu nombre completo.',
      'Birthday is required.': 'La fecha de nacimiento es obligatoria.',
      'The CPF entered is incorrect or already in use.': 'El CPF ingresado es incorrecto o ya está en uso.',
      'Opening date is required.': 'La fecha de apertura es obligatoria.',
      'The CNPJ entered is incorrect or already in use.': 'El CNPJ ingresado es incorrecto o ya está en uso.',
      'The mobile number entered is invalid.': 'El número de celular ingresado no es válido.',
      'The username cannot be only numbers.': 'El nombre de usuario no puede ser solo números.',
      'This username is already in use.': 'Este nombre de usuario ya está en uso.',
      'Your username and password must be different.': 'Tu nombre de usuario y tu contraseña deben ser diferentes.',
      'Fill in all required fields.': 'Completa todos los campos obligatorios.',
      'Change': 'Cambiar',
      'Continue': 'Continuar',
      'Back': 'Volver',
    },
  },
  components: {
    Layout,
    Languages,
    Password,
  },
  data() {
    return {
      loading: {
        plans: true,
        register: false,
        contract: false,
      },
      success: false,
      plans: {},
      step: 1,
      registrationCountry: "",
      countryOptions: [
        { abbr: "BR", code: "55", name: "Brazil", language: "pt", flag: "https://flagcdn.com/40x30/br.png" },
        { abbr: "PY", code: "595", name: "Paraguay", language: "es", flag: "https://flagcdn.com/40x30/py.png" },
      ],
      country: {
        abbr: "BR",
        code: "55",
        name: "Brazil",
        mask: "+55.###############",
      },
      countries: {},
      sponsor: {
        status: false,
        name: "",
        username: "",
        avatar: "",
      },
      contract: {
        title: "",
        content: "",
        status: false,
      },
      user: {
        plan: {
          slug: "",
          name: "",
          value: "",
        },
        country: "BR",
        sponsor: "",
        name: "",

        type: "",

        birthday: "",
        cpf: "",

        cnpj: "",
        opening: "",

        email: "",
        cellphone: "",

        username: "",
        password: "",
        term: false,
      },
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    selectedCountryOption() {
      return this.countryOptions.find((option) => option.abbr === this.registrationCountry);
    },
    naturalDocumentLabel() {
      return this.registrationCountry === "PY" ? this.t("Cédula de Identidad") : this.t("CPF");
    },
    naturalDocumentMask() {
      return this.registrationCountry === "PY" ? null : "###.###.###-##";
    },
    legalDocumentLabel() {
      return this.registrationCountry === "PY" ? this.t("RUC") : this.t("CNPJ");
    },
    legalDocumentMask() {
      return this.registrationCountry === "PY" ? null : "##.###.###/####-##";
    },
  },
  validations: {
    user: {
      country: {},
      sponsor: {},
      name: { required },

      birthday: { minLength: minLength(10), checkAge },
      cpf: {},

      cnpj: {},
      opening: {
        minLength: minLength(10),
      },

      email: { required, email },
      cellphone: { required },

      username: { required, checkUsername },
      password: { required, minLength: minLength(6) },
      term: { required },
    },
  },
  methods: {
    ...mapActions("account", ["register", "token"]),
    getPlans() {
      api.get("plan").then((response) => {
        if (response.data.status == "success") {
          this.plans = response.data.list;
        }

        this.loading.plans = false;
      });
    },
    setPlan(plan) {
      if (plan) {
        this.user.plan.slug = plan;
        this.user.plan.name = this.plans[plan].name;
        this.user.plan.value = this.plans[plan].value;
      } else {
        this.user.plan.slug = "";
        this.user.plan.name = "";
        this.user.plan.value = "";
      }
    },
    selectCountry(option) {
      this.registrationCountry = option.abbr;
      this.user.country = option.abbr;
      this.country = {
        abbr: option.abbr,
        code: option.code,
        name: option.name,
        mask: "+" + option.code + ".###############",
      };
      this.$refs.languages.setLanguage(option.language);
      this.step = 2;
    },
    goToStep(step) {
      this.step = step;
    },
    getCountries() {
      api.get("country").then((response) => {
        if (response.data.status == "success") {
          this.countries = response.data.list;
        }
      });
    },
    getSponsor() {
      if (this.user.sponsor != this.sponsor.username) {
        this.sponsor.name = "";
        this.sponsor.username = this.user.sponsor;
        this.sponsor.avatar = "";

        api
          .post("user/sponsor", {
            username: this.user.sponsor,
          })
          .then((response) => {
            if (response.data.status == "error") {
              this.sponsor.status = false;
              this.sponsor.name = "";
              this.sponsor.avatar = "";
              this.$router.push("/register");
            } else {
              this.sponsor.status = true;
              this.sponsor.name = response.data.user.name;
              this.sponsor.username = response.data.user.username;
              this.sponsor.avatar = response.data.user.avatar;

              localStorage.sponsor = JSON.stringify(response.data.user);

              this.$router.push("/register/" + response.data.user.username);
            }
          });
      }
    },
    getContract() {
      api.get("user/contract").then((response) => {
        if (response.data.status == "success") {
          this.loading.contract = true;
          this.contract.status = response.data.contract.status;
          this.contract.title = response.data.contract.title;
          this.contract.content = response.data.contract.content;
        }
      });
    },
    registerSubmit() {
      if (this.user.type == 'natural') {
        this.user.cnpj = '';
        this.user.opening = '';
      } else if (this.user.type == 'legal') {
        this.user.cpf = '';
        this.user.birthday = '';
      }

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const { name, email, cellphone, username, password } = this.user;
        if (name && email && cellphone && username && password) {
          this.loading.register = true;
          api
            .post("user", {
              country: this.registrationCountry,
              sponsor: this.user.sponsor,
              name: this.user.name,
              type: this.user.type,

              cpf: this.user.cpf,
              birthday: this.user.birthday,

              cnpj: this.user.cnpj,
              opening: this.user.opening,

              email: this.user.email,
              cellphone: this.user.cellphone,

              username: this.user.username,
              password: this.user.password,
            })
            .then((response) => {
              if (response.data.status == "success") {
                this.user.sponsor = "";
                this.user.name = "";
                this.user.type = "";
                this.user.birthday = "";
                this.user.cpf = "";
                this.user.cnpj = "";
                this.user.opening = "";
                this.user.email = "";
                this.user.cellphone = "";

                this.user.username = "";
                this.user.password = "";
                this.$v.$reset();

                this.$toast.success(this.t(response.data.message))

                this.success = true;

                const key = response.data.token;
                this.token({ key });
              } else {
                this.$toast.error(this.t(response.data.message))
              }

              this.loading.register = false;
            });
        }
      }
    },
    getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      if (match) return match[2];
      return null;
    }
  },
  mounted() {
    if (this.$route.params.sponsor) {
      this.user.sponsor = this.$route.params.sponsor;

      api
        .post("user/sponsor", {
          username: this.user.sponsor,
        })
        .then((response) => {
          if (response.data.status == "error") {
            this.sponsor.status = false;
            this.sponsor.name = "";
            this.sponsor.avatar = "";
            this.$router.push("/register");
          } else {
            this.sponsor.status = true;
            this.sponsor.name = response.data.user.name;
            this.sponsor.username = response.data.user.username;
            this.sponsor.avatar = response.data.user.avatar;

            localStorage.sponsor = JSON.stringify(response.data.user);
          }
        });
    } else {
      const sponsor = this.getCookie("app_sponsor");
      if (sponsor) {
        this.user.sponsor = sponsor;
        this.getSponsor();
      }
    }

    if (!this.user.sponsor) {
      if (localStorage.sponsor) {
        this.user.sponsor = JSON.parse(localStorage.sponsor).username;
        this.getSponsor();
      }
    }

    this.getCountries();
    this.getContract();
  },
  watch: {
    "user.country": function (value) {
      this.country = this.countries[value];
      this.country.mask = "+" + this.countries[value].code + ".###############";
    },
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="auth-login d-flex">
      <div class="login-hero d-lg-none">
        <router-link class="login-hero-logo" tag="a" to="/">
          <img src="@/assets/images/logo-white.png" alt="Nexteev" />
        </router-link>
        <svg class="login-wave" viewBox="0 0 375 60" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0,30 C120,58 260,6 375,30 L375,60 L0,60 Z" />
        </svg>
      </div>
      <div class="login-content">
        <div class="pt-5 text-center d-none d-lg-block">
          <router-link class="align-middle" tag="a" to="/">
            <img style="max-width: 250px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="pt-5 login-form">
          <div v-if="success" class="text-center pt-4 pb-4">
            <h5>
              {{ t('Congratulations!') }}<br />
              {{ t('Your account was created successfully.') }}
            </h5>
          </div>
          <div v-else>
            <h5 class="mb-4">{{ t('Register') }}</h5>

            <div v-if="alert.message" :class="'alert ' + alert.type">
              {{ alert.message }}
            </div>

            <div v-if="step == 1" class="text-center">
              <div class="row">
                <div
                  class="col-6"
                  v-for="option in countryOptions"
                  :key="option.abbr">
                  <div
                    class="country-card w-100 p-3"
                    @click="selectCountry(option)"
                  >
                    <img :src="option.flag" :alt="t(option.name)" width="40" height="30" />
                    <div class="mt-2">{{ t(option.name) }}</div>
                  </div>
                </div>
              </div>
            </div>

            <b-form v-else @submit.prevent="registerSubmit">
              <template v-if="step == 2">
                <div class="d-flex align-items-center justify-content-between mb-3 p-3 bg-soft-dark rounded">
                  <div class="d-flex align-items-center">
                    <img :src="selectedCountryOption.flag" :alt="t(selectedCountryOption.name)" width="30" height="22" class="mr-2" />
                    <span>{{ t(selectedCountryOption.name) }}</span>
                  </div>
                  <b-button class="p-0 text-dark" size="sm" variant="link" @click="goToStep(1)">{{ t('Change') }}</b-button>
                </div>
                <b-form-group id="sponsor-group" :label="t('Sponsor')" label-for="sponsor">
                  <b-form-input id="sponsor" v-model="user.sponsor" type="text" value="" :class="{ 'is-invalid': $v.user.sponsor.$error }" v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXXX'"
                    v-on:blur="getSponsor()"></b-form-input>
                  <div v-if="!$v.user.sponsor.required" class="invalid-feedback">
                    {{ t('Sponsor is required.') }}
                  </div>
                  <div v-if="sponsor.status && sponsor.name" class="d-flex my-2 p-3 bg-soft-dark rounded">
                    <div class="mr-2 align-self-center">
                      <img v-if="sponsor.avatar" class="rounded-circle header-profile-user" :src="sponsor.avatar" alt="" />
                      <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=2C00F5&color=fff&name=' + sponsor.name " alt="" />
                    </div>
                    <div class="flex-fill align-self-center">
                      <span class="text-uppercase">{{ sponsor.name }}</span>
                    </div>
                  </div>
                  <div v-else-if="
                    !sponsor.status && user.sponsor && sponsor.username
                  " class="my-2 p-3 bg-soft-danger rounded">
                    {{ t('Sponsor not found.') }}
                  </div>
                </b-form-group>
                <b-form-group id="type-group" :label="t('Person Type')" label-for="type">
                  <select v-model="user.type" class="custom-select mb-1">
                    <option value="">–</option>
                    <option value="natural">{{ t('Individual') }}</option>
                    <option value="legal">{{ t('Company') }}</option>
                  </select>
                  <div v-if="!$v.user.name.required" class="invalid-feedback">
                    {{ t('Name is required.') }}
                  </div>
                </b-form-group>

                <template v-if="user.type == 'natural'">
                  <div class="divisor mb-3">
                    <span>{{ t('Personal Information') }}</span>
                  </div>
                  <b-form-group id="name-group" :label="t('Name')" label-for="name">
                    <b-form-input id="name" v-model="user.name" type="text" :class="{ 'is-invalid': $v.user.name.$error }"></b-form-input>
                    <div v-if="!$v.user.name.required" class="invalid-feedback">
                      {{ t('Name is required.') }}
                    </div>
                  </b-form-group>
                  <b-form-group id="birthday-group" :label="t('Date of Birth')" label-for="birthday">
                    <b-form-input id="birthday" v-model="user.birthday" v-mask="'##/##/####'" type="text" inputmode="numeric" :class="{ 'is-invalid': $v.user.birthday.$error }"></b-form-input>
                    <div v-if="$v.user.birthday.$error" class="invalid-feedback">
                      <span v-if="!$v.user.birthday.required">{{ t('Date of birth is required.') }}</span>
                      <span v-if="!$v.user.birthday.minLength">{{ t('Date of birth is required.') }}</span>
                      <span v-if="!$v.user.birthday.checkAge">{{ t('You must be over 18 years old.') }}</span>
                    </div>
                  </b-form-group>
                  <b-form-group id="cpf-group" :label="naturalDocumentLabel" label-for="cpf">
                    <b-form-input id="cpf" v-model="user.cpf" type="text" inputmode="numeric" v-mask="naturalDocumentMask" :class="{ 'is-invalid': $v.user.cpf.$error }"></b-form-input>
                    <div v-if="!$v.user.cpf.required" class="invalid-feedback">
                      {{ t('CPF is required.') }}
                    </div>
                  </b-form-group>
                </template>

                <template v-if="user.type == 'legal'">
                  <div class="divisor mb-3">
                    <span>{{ t('Company Information') }}</span>
                  </div>
                  <b-form-group id="name-group" :label="t('Company Name')" label-for="name">
                    <b-form-input id="name" v-model="user.name" type="text" :class="{ 'is-invalid': $v.user.name.$error }"></b-form-input>
                    <div v-if="!$v.user.name.required" class="invalid-feedback">
                      {{ t('Company name is required.') }}
                    </div>
                  </b-form-group>
                  <b-form-group id="cnpj-group" :label="legalDocumentLabel" label-for="cnpj">
                    <b-form-input id="cnpj" v-model="user.cnpj" type="text" inputmode="numeric" v-mask="legalDocumentMask" :class="{ 'is-invalid': $v.user.cnpj.$error }"></b-form-input>
                    <div v-if="!$v.user.cnpj.required" class="invalid-feedback">
                      {{ t('CNPJ is required.') }}
                    </div>
                  </b-form-group>
                  <b-form-group id="opening-group" :label="t('Incorporation Date')" label-for="opening">
                    <b-form-input id="opening" v-model="user.opening" v-mask="'##/##/####'" type="text" inputmode="numeric" :class="{ 'is-invalid': $v.user.opening.$error }"></b-form-input>
                    <div v-if="$v.user.opening.$error" class="invalid-feedback">
                      <span v-if="!$v.user.opening.required">
                        {{ t('Incorporation date is required.') }}
                      </span>
                      <span v-if="!$v.user.opening.minLength">
                        {{ t('Incorporation date is required.') }}
                      </span>
                    </div>
                  </b-form-group>
                </template>

                <template v-if="user.type == 'natural' || user.type == 'legal'">
                  <div class="divisor mb-3">
                    <span>{{ t('Contact Information') }}</span>
                  </div>

                  <b-form-group id="email-group" :label="t('E-mail')" label-for="email">
                    <b-form-input id="email" v-model="user.email" type="email" :class="{ 'is-invalid': $v.user.email.$error }"></b-form-input>
                    <div v-if="$v.user.email.$error" class="invalid-feedback">
                      <span v-if="!$v.user.email.required">{{ t('E-mail is required.') }}</span>
                      <span v-if="!$v.user.email.email">{{ t('The email you entered is incorrect.') }}</span>
                    </div>
                  </b-form-group>
                  <b-form-group id="cellphone-group" :label="t('Mobile Phone')" label-for="cellphone">
                    <select v-model="user.country" class="custom-select mb-1">
                      <option v-for="(option,index) in countries" :key="index" :value="option.abbr" :selected="option.abbr === 'BR'">{{ option.abbr + ' ' + option.name + ' +' + option.code }}</option>
                    </select>
                    <b-input-group :prepend="country.abbr + ' +' + country.code" class="mb-2">
                      <b-form-input id="cellphone" v-model="user.cellphone" type="text" inputmode="numeric" :class="{ 'is-invalid': $v.user.cellphone.$error }" v-mask="country.mask"></b-form-input>
                    </b-input-group>
                    <div v-if="!$v.user.cellphone.required" class="invalid-feedback">
                      {{ t('Mobile phone is required.') }}
                    </div>
                  </b-form-group>

                  <div class="divisor mb-3">
                    <span>{{ t('Access Information') }}</span>
                  </div>

                  <b-form-group id="username-group" :label="t('Username')" label-for="username">
                    <b-form-input id="username" v-model="user.username" type="text" :class="{ 'is-invalid': $v.user.username.$error }" v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXXX'"></b-form-input>
                    <div v-if="!$v.user.username.required" class="invalid-feedback">
                      {{ t('Username is required.') }}
                    </div>
                    <div v-if="!$v.user.username.checkUsername" class="invalid-feedback">
                      {{ t('The username entered is incorrect.') }}
                    </div>
                  </b-form-group>
                  <b-form-group id="password-group" :label="t('Password')" label-for="password">
                    <Password v-model="user.password" :v="$v.user.password"></Password>
                  </b-form-group>

                  <div v-if="loading.contract && contract.status == 1">
                    <div v-html="contract.content" class="border p-3 overflow-auto" style="height: 200px"></div>
                    <div class="pt-3">
                      <label>
                        <input type="checkbox" v-model="user.term" :class="{ 'is-invalid': $v.user.term.$error }" />
                        {{ contract.title }}
                      </label>
                    </div>
                  </div>
                  <div class="mt-4">
                    <b-button :disabled="loading.register == true ||
                      (!user.term && contract.status == 1)
                      " type="submit" variant="default" class="btn-lg btn-block">
                      {{ t('Register') }}
                      <b-spinner v-if="loading.register" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
                    </b-button>
                  </div>
                </template>
              </template>
            </b-form>
          </div>
        </div>
        <div class="my-5 text-center">
          <p v-if="success" class="text-dark">
            <router-link tag="a" to="/login" class="btn btn-default">{{ t('Click here to sign in') }}</router-link>
          </p>
          <p v-else class="d-none text-dark">
            {{ t('Already have an account?') }}
            <router-link tag="a" to="/login" class="btn btn-outline-default btn-lg btn-block">{{ t('Sign In here') }}</router-link>
          </p>
          <Languages ref="languages" type="dropup"></Languages>
          <div v-if="sponsor.status && sponsor.name" class="mb-4">
            <span class="text-uppercase font-size-11 text-muted"><small>{{ t('REF.') }} {{ sponsor.username }}</small></span>
          </div>
          <p class="mt-4 font-size-12 text-uppercase text-muted">
            <a class="text-muted font-size-11" target="_blank" href="https://m2n.com.br/?utm_source=nexteev.com&utm_medium=link&utm_campaign=logo">
              {{ t('TECHNOLOGY BY') }}<br />
              <img alt="M2N" style="width: 50px" src="@/assets/images/logo-m2n.svg" />
            </a>
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.label-description {
  margin: -10px 0 10px 0;
}

.divisor {
  position: relative;
  text-align: center;
  text-transform: uppercase;
}

.divisor span {
  display: inline-block;
  padding: 0 5px;
  background: #fff;
  font-size: 10px;
  letter-spacing: 2px;
  color: #6E6E73;
}

.divisor:before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  left: 0;
  right: 0;
  top: 52%;
  height: 1px;
  background: #D1D1E3;
}

.country-card {
  border: 1px solid #D1D1E3;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.country-card:hover {
  border-color: #2C00F5;
  box-shadow: 0 0 0 1px #2C00F5;
}
</style>
